import { render } from "./LawyerManagement.vue?vue&type=template&id=3066a3ac"
import script from "./LawyerManagement.vue?vue&type=script&lang=js"
export * from "./LawyerManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__